import deepmerge from 'deepmerge';

const radioDimSize = size => size * 0.5;

const internalCreateTheme = global => ({
  defaults: {
    root: {
      width: global.control.dimensions.medium.height,
      height: global.control.dimensions.medium.height,
      borderRadius: global.control.state.normal.borderRadius,
      focus: {
        bg: global.control.state.focus.bg,
        borderColor: global.control.state.focus.borderColor,
        borderWidth: global.control.state.focus.borderWidth,
        shadow: global.control.state.focus.shadow,
      },
    },
    iconChecked: {
      width: radioDimSize(global.control.dimensions.medium.height),
      height: radioDimSize(global.control.dimensions.medium.height),
      color: global.control.state.normal.iconColor,
      disabled: {
        color: global.control.state.disabled.iconColor,
      },
      ['disabled+checked']: {
        color: global.control.state.selected_disabled.iconColor,
      },
      hover: {
        color: global.control.state.hover.iconColor,
      },
    },
    iconNotChecked: {
      width: radioDimSize(global.control.dimensions.medium.height),
      height: radioDimSize(global.control.dimensions.medium.height),
      color: global.control.state.normal.iconColor,
      disabled: {
        color: global.control.state.disabled.iconColor,
      },
      ['disabled+checked']: {
        color: global.control.state.selected_disabled.iconColor,
      },
      hover: {
        color: global.control.state.hover.iconColor,
      },
    },
  },
  default: {},
  xsmall: {
    root: {
      width: global.control.dimensions.xsmall.height,
      height: global.control.dimensions.xsmall.height,
    },
    iconChecked: {
      width: radioDimSize(global.control.dimensions.xsmall.height),
      height: radioDimSize(global.control.dimensions.xsmall.height),
    },
    iconNotChecked: {
      width: radioDimSize(global.control.dimensions.xsmall.height),
      height: radioDimSize(global.control.dimensions.xsmall.height),
    },
  },
  small: {
    root: {
      width: global.control.dimensions.small.height,
      height: global.control.dimensions.small.height,
    },
    iconChecked: {
      width: radioDimSize(global.control.dimensions.small.height),
      height: radioDimSize(global.control.dimensions.small.height),
    },
    iconNotChecked: {
      width: radioDimSize(global.control.dimensions.small.height),
      height: radioDimSize(global.control.dimensions.small.height),
    },
  },
  medium: {
    root: {
      width: global.control.dimensions.medium.height,
      height: global.control.dimensions.medium.height,
    },
    iconChecked: {
      width: radioDimSize(global.control.dimensions.medium.height),
      height: radioDimSize(global.control.dimensions.medium.height),
    },
    iconNotChecked: {
      width: radioDimSize(global.control.dimensions.medium.height),
      height: radioDimSize(global.control.dimensions.medium.height),
    },
  },
  large: {
    root: {
      width: global.control.dimensions.large.height,
      height: global.control.dimensions.large.height,
    },
    iconChecked: {
      width: radioDimSize(global.control.dimensions.large.height),
      height: radioDimSize(global.control.dimensions.large.height),
    },
    iconNotChecked: {
      width: radioDimSize(global.control.dimensions.large.height),
      height: radioDimSize(global.control.dimensions.large.height),
    },
  },
  xlarge: {
    root: {
      width: global.control.dimensions.xlarge.height,
      height: global.control.dimensions.xlarge.height,
    },
    iconChecked: {
      width: radioDimSize(global.control.dimensions.xlarge.height),
      height: radioDimSize(global.control.dimensions.xlarge.height),
    },
    iconNotChecked: {
      width: radioDimSize(global.control.dimensions.xlarge.height),
      height: radioDimSize(global.control.dimensions.xlarge.height),
    },
  },
});

const create = ({ defaults }) => {
  const radioTheme = internalCreateTheme(defaults);
  return {
    default: deepmerge(radioTheme.defaults, radioTheme.default),
    xsmall: deepmerge(radioTheme.defaults, radioTheme.xsmall),
    small: deepmerge(radioTheme.defaults, radioTheme.small),
    medium: deepmerge(radioTheme.defaults, radioTheme.medium),
    large: deepmerge(radioTheme.defaults, radioTheme.large),
    xlarge: deepmerge(radioTheme.defaults, radioTheme.xlarge),
  };
};

export default create;
